import React from 'react';
import { useNavigate } from "react-router-dom";

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import FournisseurGestionAutocomplete from 'components/Shared/FournisseurGestionAutocomplete';


const AdministrationFournisseurs = () => {

    const navigate = useNavigate();
    const [fournisseur, setFournisseur] = React.useState(null);


    return (
        <>
            <Typography gutterBottom variant="h5">
                Administration des fournisseurs
            </Typography>


            <Card>
                <CardHeader
                    title={<Typography variant="h6">Choix d'un fournisseur à éditer</Typography>}
                />
                <CardContent>

                    <FournisseurGestionAutocomplete
                        autoFocus
                        onChange={e => setFournisseur(e)}
                    />


                </CardContent>

                <CardActions sx={{ justifyContent: 'right' }}>


                    <Button
                        disabled={!fournisseur || !fournisseur.id}
                        color="secondary"
                        variant="contained"
                        onClick={() => navigate(`/administration/fournisseurs/${fournisseur.id}`)}
                    >
                        Éditer
                    </Button>

                </CardActions>



            </Card>

        </>

        );

};





//AdministrationFournisseurs.propTypes = {
//};

export default AdministrationFournisseurs;